export default {
  "nav.home": "Home",
  "nav.article": "USFans Guide",
  "nav.categories": "Categories",
  "nav.faq": "FAQ",
  "nav.guides": "Guides",
  "nav.shoppingGuide": "Shopping Guide",
  "nav.openSpreadsheet": "USFans Spreadsheet",

  "lang.label": "Language",

  "cta.exploreSpreadsheet": "Explore USFans Spreadsheet",
  "cta.buyNow": "Buy It Now",
  "cta.visitMain": "Visit Main Website",
  "cta.browseGuides": "Browse USFans Guides",
  "cta.readArticle": "Read the Full Guide",
  "cta.openSpreadsheet": "Open the USFans Spreadsheet",
  "cta.backHome": "Back to Homepage",

  "categories.title": "Browse by Category",
  "categories.subtitle": "Jump straight to a product category on the main website",
  "categories.selectLabel": "Choose a category",
  "categories.placeholder": "Select a category to continue",
  "categories.all": "All Categories",

  "categories.shoes": "Shoes",
  "categories.hoodies": "Hoodies/Sweaters",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jackets",
  "categories.pants": "Pants/Shorts",
  "categories.headwear": "Headwear",
  "categories.sets": "Sets",
  "categories.underwear": "Underwear/Underpants",
  "categories.jersey": "Jersey",
  "categories.accessories": "Accessories",
  "categories.bags": "Bags",
  "categories.belts": "Belts",
  "categories.perfumes": "Perfumes",
  "categories.other": "Other Stuff",

  "footer.tagline": "An independent resource hub for exploring the USFans Spreadsheet and related guides.",
  "footer.disclaimer": "USFansLink.wiki is an independent informational resource and is not necessarily affiliated with or endorsed by USFans.",
  "footer.quickLinks": "Quick Links",
  "footer.categories": "Categories",
  "footer.resources": "Resources",
  "footer.language": "Language",
  "footer.rights": "All rights reserved.",
  "footer.about": "About",
  "footer.disclaimerLink": "Disclaimer",
  "footer.safety": "Safety Center",
};